import { useState } from "react";
import { Row, Col, Form } from "antd";
import { useDispatch } from "react-redux";
import { fetchAdminLeaves } from "../Slices/adminLeaveSlice";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { AntdButton, DatePickerField, SelectInput } from "../blueplanitUtils/InputField";
import { getOptionsByPath } from "../utilsdata";
import { ADMIN_LEAVES, EMPLOYEE_LEAVES, LEAVE_STATUS, LEAVE_TYPE } from "../Dropdownmanager";
import { useEffect } from "react";
import { setFilters, clearFilters } from "../Slices/adminLeaveSlice";

const LeaveFilter = () => {
  const filters = useSelector(
    (state) => state.adminLeave?.filters
  ) ?? {
    employeeName: "",
    selectedLeaveType: "",
    selectedLeaveStatus: "",
    selectedDepartment: "",
    selectedDate: null,
    selectedDateTwo: null,
  };



  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails)
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const teamReports = loginUser?.teamsReportDirect?.map(item => item?.reportingId) || [];

  const dispatch = useDispatch();

  const employees = useSelector((state) => state.loginUserInfo.allUsers);

  const departmentOptions = [
    { label: "All Departments", value: "" }, // empty value for all
    ...Array.from(
      new Set(employees.map(emp => emp.department).filter(Boolean))
    ).map(dep => ({
      label: dep,
      value: dep
    }))
  ];


  const handleKeyDown = (e) => {
    let value = e.target.value.replace(/[^\d/]/g, '');// Remove non-numeric and non-slash characters

    if (value.length >= 10 && e.key !== "Backspace") {
      e.preventDefault(); // Prevent typing more than 10 characters
      return;
    }

    value = value
      .replace(/^(\d{2})(\d)$/g, '$1/$2') // Add '/' after first two digits (DD/)
      .replace(/^(\d{2}\/\d{2})(\d{1,4})$/g, '$1/$2'); // Add '/' after month (DD/MM/YYYY)

    e.target.value = value;
  };

  const isInitialFetched = useSelector(
    (state) => state.adminLeave.isInitialFetched
  );

  useEffect(() => {
    if (!loginUser || isInitialFetched) return;

    const role = loginUser.role;
    const userDepartment = loginUser.department;

    const payload = {
      role,
      userDepartment,
      department: "ALL",
      loginUserId: loginUser?.id,
    };

    dispatch(fetchAdminLeaves(payload));
  }, [loginUser, isInitialFetched, dispatch]);



  const handleSearch = () => {
    const role = loginUser?.role;
    const userDepartment = loginUser?.department;
    const hasDirectReports = teamReports.length > 0;

    const payload = {
      fromDate: filters.selectedDate ? dayjs(filters.selectedDate).format("YYYY-MM-DD") : undefined,
      toDate: filters.selectedDateTwo ? dayjs(filters.selectedDateTwo).format("YYYY-MM-DD") : undefined,
      leaveType: filters.selectedLeaveType || undefined,
      leaveStatus: filters.selectedLeaveStatus || undefined,
      role: loginUser?.role,
      userDepartment: userDepartment,
      department: filters.selectedDepartment === "" ? "ALL" : filters.selectedDepartment,
      loginUserId: loginUser?.id,
    };

    if (filters.employeeName) {
      payload.employeeId = filters.employeeName;
    }

    dispatch(fetchAdminLeaves(payload));

  };


  const handleClear = () => {
    dispatch(clearFilters());

    const role = loginUser?.role;
    const userDepartment = loginUser?.department;

    const payload = { role, userDepartment, department: "ALL" };
    if (!(role === "Super Admin" || userDepartment === "HR & Admin")) {
      payload.empid = teamReports?.length ? teamReports : [];
    }
    dispatch(fetchAdminLeaves(payload));
  };


  const enrichedLeaves = employees
    ?.filter(emp => {
      if (!filters?.selectedDepartment) return true;
      return emp.department === filters.selectedDepartment;
    })
    .map(emp => ({
      employeeId: emp.id,
      username: `${emp.firstname} ${emp.lastname}`,
      department: emp.department,
    }));




  return (
    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]} className="filter-row">
      <Col span={4}>
        <Form.Item labelCol={{ span: 24 }}>
          <SelectInput
            label="Employee Name"
            value={filters.employeeName}   // use Redux filter state
            onChange={(value) => dispatch(setFilters({ employeeName: value }))} // dispatch action to update Redux state
            placeholder="Select Employee"
             showSearch
              optionFilterProp="label"
            options={enrichedLeaves?.map((employee) => (
              {
                label: employee.username,
                value: employee.employeeId // Use a unique identifier like emp
              }
            ))}

          />
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item labelCol={{ span: 24 }}>
          <SelectInput
            label="Department"
            value={filters.selectedDepartment}
            onChange={(value) => dispatch(setFilters({ selectedDepartment: value }))} // dispatch action to update Redux state
            placeholder="Select Department"
            options={departmentOptions}
          />
        </Form.Item>
      </Col>


      <Col span={4}>
        <Form.Item labelCol={{ span: 24 }}>
          <SelectInput
            label="Leave Type"
            value={filters.selectedLeaveType}   // use Redux filter state
            onChange={(value) => dispatch(setFilters({ selectedLeaveType: value }))} // dispatch action to update Redux state
            placeholder="Select Leave Type"
            options={getOptionsByPath(NestedDatabucket, [EMPLOYEE_LEAVES, LEAVE_TYPE])}
          />
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item labelCol={{ span: 24 }}>
          <SelectInput
            label="Leave Status"
            value={filters.selectedLeaveStatus}
            onChange={(value) => dispatch(setFilters({ selectedLeaveStatus: value }))} // dispatch action to update Redux state
            placeholder="Select Leave Status"
            options={getOptionsByPath(NestedDatabucket, [ADMIN_LEAVES, LEAVE_STATUS])}

          />
        </Form.Item>
      </Col>
      <Col span={2}>
        <Form.Item labelCol={{ span: 24 }}>
          <DatePickerField
            label="From Date"
            value={filters.selectedDate ? dayjs(filters.selectedDate) : null} // use Redux
            onChange={(date) =>
              dispatch(
                setFilters({
                  selectedDate: date ? date.format("YYYY-MM-DD") : null,
                })
              )
            }
            format="DD/MM/YYYY"
            placeholder="Select From Date"
            allowClear={true}
            onKeyDown={handleKeyDown}
            disabledDate={(current) => {
              return (
                current &&
                (filters.selectedDateTwo && current > dayjs(filters.selectedDateTwo).startOf("day") || current > dayjs().endOf("day"))
              );
            }}

          />

        </Form.Item>
      </Col>

      <Col span={2}>
        <Form.Item labelCol={{ span: 24 }}>
          <DatePickerField
            label="To Date"
            value={filters.selectedDateTwo ? dayjs(filters.selectedDateTwo) : null}
            onChange={(date) => dispatch(setFilters({ selectedDateTwo: date ? date.format("YYYY-MM-DD") : null }))}
            format="DD/MM/YYYY"
            placeholder="Select To Date"
            allowClear={true}
            onKeyDown={handleKeyDown}
            disabledDate={(current) => {
              return current && filters.selectedDate && current < dayjs(filters.selectedDate).startOf("day");
            }}


          />
        </Form.Item>
      </Col>

      <Col span={4} style={{ marginTop: '25px' }}>
        <AntdButton label="Search" color='primary' style={{ marginRight: '10px' }} variant='solid' onClick={handleSearch} />

        <AntdButton label="Clear" color='default' variant='outlined' onClick={handleClear} />

      </Col>
    </Row>
  );
};

export default LeaveFilter;
